import {
  createMaintenanceItemAPIClient,
  createNotificationsAPIClient,
  createPilotAPIClient, createQuickActionAPIClient,
  createRuleAPIClient,
  createRuleV2APIClient,
  createTagAPIClient,
  createZoneAPIClient,
} from '@api/MyTripsAPIClientFactory'
import Stage from '@util/stage'
import { LoadState } from '@util/types'

const pilotApiClient = createPilotAPIClient()
const tagApiClient = createTagAPIClient()
const zoneApiClient = createZoneAPIClient()
const ruleApiClient = createRuleAPIClient()
const ruleV2ApiClient = createRuleV2APIClient()
const notificationsApiClient = createNotificationsAPIClient()
const maintenanceItemsApiClient = createMaintenanceItemAPIClient()
const quickActionApiClient = createQuickActionAPIClient()

function dispatchResetCarHealth (dispatch) {
  dispatch('CarHealth/resetCarHealth', {}, { root: true })
}

function dispatchResetStatistics (dispatch) {
  dispatch('Statistic/resetStatistics', {}, { root: true })
}

function dispatchRefreshRules (dispatch) {
  dispatch('refreshRules')
  dispatch('refreshRulesV2')
}

function createState () {
  return {
    stage: Stage.PROD,
    getPilotsRequest: {
      status: LoadState.None,
      response: [],
    },
    getPilotSuggestionsRequest: {
      status: LoadState.None,
      response: []
    },
    getTagsRequest: {
      status: LoadState.None,
      response: [],
    },
    getQuickActionTagsRequest: {
      status: LoadState.None,
      response: [],
    },
    getZonesRequest: {
      status: LoadState.None,
      response: [],
    },
    getRulesRequest: {
      status: LoadState.None,
      response: [],
    },
    getRulesV2Request: {
      status: LoadState.None,
      response: [],
    },
    getZoneSuggestionsRequest: {
      status: LoadState.None,
      response: [],
    },
    getNotificationsRequest: {
      status: LoadState.None,
      vehicleId: null as number,
      response: [],
    },
    getAvailableNotificationChannelsRequest: {
      status: LoadState.None,
      response: [],
    },
    getMaintenanceItemsRequest: {
      status: LoadState.None,
      response: [],
    },
    createPilotRequest: {
      status: LoadState.None,
      response: {}
    },
    createTagRequest: {
      status: LoadState.None,
      response: {}
    },
    createZoneRequest: {
      status: LoadState.None,
      response: {}
    },
    createRuleRequest: {
      status: LoadState.None,
      response: {}
    },
    createRuleV2Request: {
      status: LoadState.None,
      response: {}
    },
    createMaintenanceItemRequest: {
      status: LoadState.None,
      response: {}
    },
    updatePilotRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    updateTagRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    updateZoneRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    updateRuleRequest: {
      id: null as string,
      status: LoadState.None,
      response: {}
    },
    updateRuleV2Request: {
      id: null as string,
      status: LoadState.None,
      response: {}
    },
    updateRuleActiveRequest: {
      id: null as string,
      status: LoadState.None,
      response: {}
    },
    updateNotificationRequest: {
      event: null as string,
      status: LoadState.None,
      response: {}
    },
    updateNotificationActiveRequest: {
      event: null as string,
      status: LoadState.None,
      response: {}
    },
    updateMaintenanceItemRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    updateMaintenanceItemActiveRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    deletePilotRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    deleteTagRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    deleteZoneRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    deleteRuleRequest: {
      id: null as string,
      status: LoadState.None,
      response: {}
    },
    deleteMaintenanceItemRequest: {
      id: null as number,
      status: LoadState.None,
      response: {}
    },
    triggerGisFavoriteSynchronizationRequest: {
      status: LoadState.None,
      response: {}
    }
  }
}

export default {
  namespaced: true,

  state: createState,

  mutations: {
    SET_STAGE (state, stage) {
      state.stage = stage
    },
    GET_PILOTS_REQUEST (state) {
      state.getPilotsRequest.status = LoadState.Loading
    },
    GET_PILOTS_RESPONSE (state, payload) {
      state.getPilotsRequest.status = LoadState.Success
      state.getPilotsRequest.response = payload
    },
    GET_PILOTS_ERROR_RESPONSE (state, payload) {
      state.getPilotsRequest.status = LoadState.Error
      state.getPilotsRequest.response = payload
    },
    GET_PILOT_SUGGESTIONS_REQUEST (state) {
      state.getPilotSuggestionsRequest.status = LoadState.Loading
    },
    GET_PILOT_SUGGESTIONS_RESPONSE (state, payload) {
      state.getPilotSuggestionsRequest.status = LoadState.Success
      state.getPilotSuggestionsRequest.response = payload
    },
    GET_PILOT_SUGGESTIONS_ERROR_RESPONSE (state, payload) {
      state.getPilotSuggestionsRequest.status = LoadState.Error
      state.getPilotSuggestionsRequest.response = payload
    },
    GET_TAGS_REQUEST (state) {
      state.getTagsRequest.status = LoadState.Loading
    },
    GET_TAGS_RESPONSE (state, payload) {
      state.getTagsRequest.status = LoadState.Success
      state.getTagsRequest.response = payload
    },
    GET_TAGS_ERROR_RESPONSE (state, payload) {
      state.getTagsRequest.status = LoadState.Error
      state.getTagsRequest.response = payload
    },
    GET_QUICK_ACTION_TAGS_REQUEST (state) {
      state.getQuickActionTagsRequest.status = LoadState.Loading
    },
    GET_QUICK_ACTION_TAGS_RESPONSE (state, payload) {
      state.getQuickActionTagsRequest.status = LoadState.Success
      state.getQuickActionTagsRequest.response = payload
    },
    GET_QUICK_ACTION_TAGS_ERROR_RESPONSE (state, payload) {
      state.getQuickActionTagsRequest.status = LoadState.Error
      state.getQuickActionTagsRequest.response = payload
    },
    GET_ZONES_REQUEST (state) {
      state.getZonesRequest.status = LoadState.Loading
    },
    GET_ZONES_RESPONSE (state, payload) {
      state.getZonesRequest.status = LoadState.Success
      state.getZonesRequest.response = payload
    },
    GET_ZONES_ERROR_RESPONSE (state, payload) {
      state.getZonesRequest.status = LoadState.Error
      state.getZonesRequest.response = payload
    },
    GET_RULES_REQUEST (state) {
      state.getRulesRequest.status = LoadState.Loading
    },
    GET_RULES_RESPONSE (state, payload) {
      state.getRulesRequest.status = LoadState.Success
      state.getRulesRequest.response = payload
    },
    GET_RULES_ERROR_RESPONSE (state, payload) {
      state.getRulesRequest.status = LoadState.Error
      state.getRulesRequest.response = payload
    },
    GET_RULES_V2_REQUEST (state) {
      state.getRulesV2Request.status = LoadState.Loading
    },
    GET_RULES_V2_RESPONSE (state, payload) {
      state.getRulesV2Request.status = LoadState.Success
      state.getRulesV2Request.response = payload
    },
    GET_RULES_V2_ERROR_RESPONSE (state, payload) {
      state.getRulesV2Request.status = LoadState.Error
      state.getRulesV2Request.response = payload
    },
    GET_ZONE_SUGGESTIONS_REQUEST (state) {
      state.getZoneSuggestionsRequest.status = LoadState.Loading
    },
    GET_ZONE_SUGGESTIONS_RESPONSE (state, payload) {
      state.getZoneSuggestionsRequest.status = LoadState.Success
      state.getZoneSuggestionsRequest.response = payload
    },
    GET_ZONE_SUGGESTIONS_ERROR_RESPONSE (state, payload) {
      state.getZoneSuggestionsRequest.status = LoadState.Error
      state.getZoneSuggestionsRequest.response = payload
    },
    GET_NOTIFICATIONS_REQUEST (state, vehicleId) {
      state.getNotificationsRequest.status = LoadState.Loading
      state.getNotificationsRequest.vehicleId = vehicleId
    },
    GET_NOTIFICATIONS_RESPONSE (state, payload) {
      state.getNotificationsRequest.status = LoadState.Success
      state.getNotificationsRequest.response = payload
    },
    GET_NOTIFICATIONS_ERROR_RESPONSE (state, payload) {
      state.getNotificationsRequest.status = LoadState.Error
      state.getNotificationsRequest.response = payload
    },
    GET_AVAILABLE_NOTIFICATION_CHANNELS_REQUEST (state) {
      state.getAvailableNotificationChannelsRequest.status = LoadState.Loading
    },
    GET_AVAILABLE_NOTIFICATION_CHANNELS_RESPONSE (state, payload) {
      state.getAvailableNotificationChannelsRequest.status = LoadState.Success
      state.getAvailableNotificationChannelsRequest.response = payload
    },
    GET_AVAILABLE_NOTIFICATION_CHANNELS_ERROR_RESPONSE (state, payload) {
      state.getAvailableNotificationChannelsRequest.status = LoadState.Error
      state.getAvailableNotificationChannelsRequest.response = payload
    },
    GET_MAINTENANCE_ITEMS_REQUEST (state) {
      state.getMaintenanceItemsRequest.status = LoadState.Loading
    },
    GET_MAINTENANCE_ITEMS_RESPONSE (state, payload) {
      state.getMaintenanceItemsRequest.status = LoadState.Success
      state.getMaintenanceItemsRequest.response = payload
    },
    GET_MAINTENANCE_ITEMS_ERROR_RESPONSE (state, payload) {
      state.getMaintenanceItemsRequest.status = LoadState.Error
      state.getMaintenanceItemsRequest.response = payload
    },
    CREATE_PILOT_REQUEST (state) {
      state.createPilotRequest.status = LoadState.Loading
    },
    CREATE_PILOT_RESPONSE (state, payload) {
      state.createPilotRequest.status = LoadState.Success
      state.createPilotRequest.response = payload

      if (state.getPilotsRequest.status === LoadState.Success) {
        state.getPilotsRequest.response = [...state.getPilotsRequest.response, payload]
      }

      if (state.getPilotSuggestionsRequest.status === LoadState.Success && payload.cknr) {
        state.getPilotSuggestionsRequest.response = state.getPilotSuggestionsRequest.response.filter(ps => ps.cknr !== payload.cknr)
      }
    },
    CREATE_PILOT_ERROR_RESPONSE (state, payload) {
      state.createPilotRequest.status = LoadState.Error
      state.createPilotRequest.response = payload
    },
    CREATE_TAG_REQUEST (state) {
      state.createTagRequest.status = LoadState.Loading
    },
    CREATE_TAG_RESPONSE (state, payload) {
      state.createTagRequest.status = LoadState.Success
      state.createTagRequest.response = payload

      if (state.getTagsRequest.status === LoadState.Success) {
        state.getTagsRequest.response = [...state.getTagsRequest.response, payload]
      }
    },
    CREATE_TAG_ERROR_RESPONSE (state, payload) {
      state.createTagRequest.status = LoadState.Error
      state.createTagRequest.response = payload
    },
    CREATE_ZONE_REQUEST (state) {
      state.createZoneRequest.status = LoadState.Loading
    },
    CREATE_ZONE_RESPONSE (state, payload) {
      state.createZoneRequest.status = LoadState.Success
      state.createZoneRequest.response = payload

      if (state.getZonesRequest.status === LoadState.Success) {
        state.getZonesRequest.response = [...state.getZonesRequest.response, payload]
      }
    },
    CREATE_ZONE_ERROR_RESPONSE (state, payload) {
      state.createZoneRequest.status = LoadState.Error
      state.createZoneRequest.response = payload
    },
    CREATE_RULE_REQUEST (state) {
      state.createRuleRequest.status = LoadState.Loading
    },
    CREATE_RULE_RESPONSE (state, payload) {
      state.createRuleRequest.status = LoadState.Success
      state.createRuleRequest.response = payload

      if (state.getRulesRequest.status === LoadState.Success) {
        state.getRulesRequest.response = [...state.getRulesRequest.response, payload]
      }
    },
    CREATE_RULE_ERROR_RESPONSE (state, payload) {
      state.createRuleRequest.status = LoadState.Error
      state.createRuleRequest.response = payload
    },
    CREATE_RULE_V2_REQUEST (state) {
      state.createRuleV2Request.status = LoadState.Loading
    },
    CREATE_RULE_V2_RESPONSE (state, payload) {
      state.createRuleV2Request.status = LoadState.Success
      state.createRuleV2Request.response = payload

      if (state.getRulesV2Request.status === LoadState.Success) {
        state.getRulesV2Request.response = [...state.getRulesV2Request.response, payload]
      }
    },
    CREATE_RULE_V2_ERROR_RESPONSE (state, payload) {
      state.createRuleV2Request.status = LoadState.Error
      state.createRuleV2Request.response = payload
    },
    CREATE_MAINTENANCE_ITEM_REQUEST (state) {
      state.createMaintenanceItemRequest.status = LoadState.Loading
    },
    CREATE_MAINTENANCE_ITEM_RESPONSE (state, payload) {
      state.createMaintenanceItemRequest.status = LoadState.Success
      state.createMaintenanceItemRequest.response = payload
    },
    CREATE_MAINTENANCE_ITEM_ERROR_RESPONSE (state, payload) {
      state.createMaintenanceItemRequest.status = LoadState.Error
      state.createMaintenanceItemRequest.response = payload
    },
    UPDATE_PILOT_REQUEST (state, id) {
      state.updatePilotRequest.status = LoadState.Loading
      state.updatePilotRequest.id = id
    },
    UPDATE_PILOT_RESPONSE (state, payload) {
      state.updatePilotRequest.status = LoadState.Success
      state.updatePilotRequest.response = payload

      if (state.getPilotsRequest.status === LoadState.Success) {
        state.getPilotsRequest.response = state.getPilotsRequest.response
          .map(storedPilot => storedPilot.id === payload.id ? payload : storedPilot)
      }
    },
    UPDATE_PILOT_ERROR_RESPONSE (state, payload) {
      state.updatePilotRequest.status = LoadState.Error
      state.updatePilotRequest.response = payload
    },
    UPDATE_TAG_REQUEST (state, id) {
      state.updateTagRequest.status = LoadState.Loading
      state.updateTagRequest.id = id
    },
    UPDATE_TAG_RESPONSE (state, payload) {
      state.updateTagRequest.status = LoadState.Success
      state.updateTagRequest.response = payload

      if (state.getTagsRequest.status === LoadState.Success) {
        state.getTagsRequest.response = state.getTagsRequest.response
          .map(storedTag => storedTag.id === payload.id ? payload : storedTag)
      }
    },
    UPDATE_TAG_ERROR_RESPONSE (state, payload) {
      state.updateTagRequest.status = LoadState.Error
      state.updateTagRequest.response = payload
    },
    UPDATE_ZONE_REQUEST (state, id) {
      state.updateZoneRequest.status = LoadState.Loading
      state.updateZoneRequest.id = id
    },
    UPDATE_ZONE_RESPONSE (state, payload) {
      state.updateZoneRequest.status = LoadState.Success
      state.updateZoneRequest.response = payload

      if (state.getZonesRequest.status === LoadState.Success) {
        state.getZonesRequest.response = state.getZonesRequest.response
          .map(storedZone => storedZone.id === payload.id ? payload : storedZone)
      }
    },
    UPDATE_ZONE_ERROR_RESPONSE (state, payload) {
      state.updateZoneRequest.status = LoadState.Error
      state.updateZoneRequest.response = payload
    },
    UPDATE_RULE_REQUEST (state, id) {
      state.updateRuleRequest.status = LoadState.Loading
      state.updateRuleRequest.id = id
    },
    UPDATE_RULE_RESPONSE (state, payload) {
      state.updateRuleRequest.status = LoadState.Success
      state.updateRuleRequest.response = payload

      if (state.getRulesRequest.status === LoadState.Success) {
        state.getRulesRequest.response = state.getRulesRequest.response
          .map(storedRule => storedRule.id === payload.id ? payload : storedRule)
      }
    },
    UPDATE_RULE_ERROR_RESPONSE (state, payload) {
      state.updateRuleRequest.status = LoadState.Error
      state.updateRuleRequest.response = payload
    },
    UPDATE_RULE_V2_REQUEST (state, id) {
      state.updateRuleV2Request.status = LoadState.Loading
      state.updateRuleV2Request.id = id
    },
    UPDATE_RULE_V2_RESPONSE (state, payload) {
      state.updateRuleV2Request.status = LoadState.Success
      state.updateRuleV2Request.response = payload

      if (state.getRulesV2Request.status === LoadState.Success) {
        state.getRulesV2Request.response = state.getRulesV2Request.response
          .map(storedRule => storedRule.id === payload.id ? payload : storedRule)
      }
    },
    UPDATE_RULE_V2_ERROR_RESPONSE (state, payload) {
      state.updateRuleV2Request.status = LoadState.Error
      state.updateRuleV2Request.response = payload
    },
    UPDATE_RULE_ACTIVE_REQUEST (state, payload) {
      state.updateRuleActiveRequest.status = LoadState.Loading
      state.updateRuleActiveRequest.id = payload.id

      if (state.getRulesRequest.status === LoadState.Success) {
        state.getRulesRequest.response = state.getRulesRequest.response
          .map(storedRule => storedRule.id === state.updateRuleActiveRequest.id ? { ...storedRule, active: payload.active } : storedRule)
      }

      if (state.getRulesV2Request.status === LoadState.Success) {
        state.getRulesV2Request.response = state.getRulesV2Request.response
          .map(storedRule => storedRule.id === state.updateRuleActiveRequest.id ? { ...storedRule, active: payload.active } : storedRule)
      }
    },
    UPDATE_RULE_ACTIVE_RESPONSE (state, active) {
      state.updateRuleActiveRequest.status = LoadState.Success
      state.updateRuleActiveRequest.response = active
    },
    UPDATE_RULE_ACTIVE_ERROR_RESPONSE (state, payload) {
      state.updateRuleActiveRequest.status = LoadState.Error
      state.updateRuleActiveRequest.response = payload

      if (state.getRulesRequest.status === LoadState.Success) {
        state.getRulesRequest.response = state.getRulesRequest.response
          .map(storedRule => storedRule.id === state.updateRuleActiveRequest.id ? { ...storedRule, active: !storedRule.active } : storedRule)
      }

      if (state.getRulesV2Request.status === LoadState.Success) {
        state.getRulesV2Request.response = state.getRulesV2Request.response
          .map(storedRule => storedRule.id === state.updateRuleActiveRequest.id ? { ...storedRule, active: !storedRule.active } : storedRule)
      }
    },
    UPDATE_MAINTENANCE_ITEM_REQUEST (state) {
      state.updateMaintenanceItemRequest.status = LoadState.Loading
    },
    UPDATE_MAINTENANCE_ITEM_RESPONSE (state, payload) {
      state.updateMaintenanceItemRequest.status = LoadState.Success
      state.updateMaintenanceItemRequest.response = payload
    },
    UPDATE_MAINTENANCE_ITEM_ERROR_RESPONSE (state, payload) {
      state.updateMaintenanceItemRequest.status = LoadState.Error
      state.updateMaintenanceItemRequest.response = payload
    },
    UPDATE_MAINTENANCE_ITEM_ACTIVE_REQUEST (state, payload) {
      state.updateMaintenanceItemActiveRequest.status = LoadState.Loading

      if (state.getMaintenanceItemsRequest.status === LoadState.Success) {
        state.getMaintenanceItemsRequest.response = state.getMaintenanceItemsRequest.response
          .map(storedItem => storedItem.id === payload.id ? { ...storedItem, active: payload.active } : storedItem)
      }
    },
    UPDATE_MAINTENANCE_ITEM_ACTIVE_RESPONSE (state, active) {
      state.updateMaintenanceItemActiveRequest.status = LoadState.Success
      state.updateMaintenanceItemActiveRequest.response = active
    },
    UPDATE_MAINTENANCE_ITEM_ACTIVE_ERROR_RESPONSE (state, payload) {
      state.updateMaintenanceItemActiveRequest.status = LoadState.Error
      state.updateMaintenanceItemActiveRequest.response = payload.response

      if (state.getMaintenanceItemsRequest.status === LoadState.Success) {
        state.getMaintenanceItemsRequest.response = state.getMaintenanceItemsRequest.response
          .map(storedItem => storedItem.id === payload.id ? { ...storedItem, active: !storedItem.active } : storedItem)
      }
    },
    UPDATE_NOTIFICATION_REQUEST (state, payload) {
      state.updateNotificationRequest.status = LoadState.Loading
      state.updateNotificationRequest.event = payload.notification.event

      if (state.getNotificationsRequest.status === LoadState.Success && payload.updateFromOverview) {
        state.getNotificationsRequest.response = state.getNotificationsRequest.response
          .map(storedNotification => storedNotification.event === payload.notification.event ? { ...storedNotification, ...payload.notification } : storedNotification)
      }
    },
    UPDATE_NOTIFICATION_RESPONSE (state, payload) {
      state.updateNotificationRequest.status = LoadState.Success
      state.updateNotificationRequest.response = null

      if (state.getNotificationsRequest.status === LoadState.Success) {
        state.getNotificationsRequest.response = state.getNotificationsRequest.response
          .map(storedNotification => storedNotification.event === payload.event ? { ...storedNotification, ...payload } : storedNotification)
      }
    },
    UPDATE_NOTIFICATION_ERROR_RESPONSE (state, payload) {
      state.updateNotificationRequest.status = LoadState.Error
      state.updateNotificationRequest.response = payload
    },
    UPDATE_NOTIFICATION_ACTIVE_REQUEST (state, payload) {
      state.updateNotificationActiveRequest.status = LoadState.Loading
      state.updateNotificationActiveRequest.event = payload.event

      if (state.getNotificationsRequest.status === LoadState.Success) {
        state.getNotificationsRequest.response = state.getNotificationsRequest.response
          .map(stored => stored.event === state.updateNotificationActiveRequest.event ? { ...stored, active: payload.active } : stored)
      }
    },
    UPDATE_NOTIFICATION_ACTIVE_RESPONSE (state) {
      state.updateNotificationActiveRequest.status = LoadState.Success
      state.updateNotificationActiveRequest.response = null
    },
    UPDATE_NOTIFICATION_ACTIVE_ERROR_RESPONSE (state, payload) {
      state.updateNotificationActiveRequest.status = LoadState.Error
      state.updateNotificationActiveRequest.response = payload

      if (state.getNotificationsRequest.status === LoadState.Success) {
        state.getNotificationsRequest.response = state.getNotificationsRequest.response
          .map(stored => stored.event === state.updateNotificationActiveRequest.event ? { ...stored, active: !stored.active } : stored)
      }
    },
    DELETE_PILOT_REQUEST (state, id) {
      state.deletePilotRequest.status = LoadState.Loading
      state.deletePilotRequest.id = id
    },
    DELETE_PILOT_RESPONSE (state, payload) {
      state.deletePilotRequest.status = LoadState.Success
      state.deletePilotRequest.response = payload

      if (state.getPilotsRequest.status === LoadState.Success) {
        state.getPilotsRequest.response = state.getPilotsRequest.response
          .filter(storedPilot => storedPilot.id !== state.deletePilotRequest.id)
      }
    },
    DELETE_PILOT_ERROR_RESPONSE (state, payload) {
      state.deletePilotRequest.status = LoadState.Error
      state.deletePilotRequest.response = payload
    },
    DELETE_TAG_REQUEST (state, id) {
      state.deleteTagRequest.status = LoadState.Loading
      state.deleteTagRequest.id = id
    },
    DELETE_TAG_RESPONSE (state, payload) {
      state.deleteTagRequest.status = LoadState.Success
      state.deleteTagRequest.response = payload

      if (state.getTagsRequest.status === LoadState.Success) {
        state.getTagsRequest.response = state.getTagsRequest.response
          .filter(storedTag => storedTag.id !== state.deleteTagRequest.id)
      }
    },
    DELETE_TAG_ERROR_RESPONSE (state, payload) {
      state.deleteTagRequest.status = LoadState.Error
      state.deleteTagRequest.response = payload
    },
    DELETE_ZONE_REQUEST (state, id) {
      state.deleteZoneRequest.status = LoadState.Loading
      state.deleteZoneRequest.id = id
    },
    DELETE_ZONE_RESPONSE (state, payload) {
      state.deleteZoneRequest.status = LoadState.Success
      state.deleteZoneRequest.response = payload

      if (state.getZonesRequest.status === LoadState.Success) {
        state.getZonesRequest.response = state.getZonesRequest.response
          .filter(storedZone => storedZone.id !== state.deleteZoneRequest.id)
      }
    },
    DELETE_ZONE_ERROR_RESPONSE (state, payload) {
      state.deleteZoneRequest.status = LoadState.Error
      state.deleteZoneRequest.response = payload
    },
    DELETE_RULE_REQUEST (state, id) {
      state.deleteRuleRequest.status = LoadState.Loading
      state.deleteRuleRequest.id = id
    },
    DELETE_RULE_RESPONSE (state, payload) {
      state.deleteRuleRequest.status = LoadState.Success
      state.deleteRuleRequest.response = payload

      if (state.getRulesRequest.status === LoadState.Success) {
        state.getRulesRequest.response = state.getRulesRequest.response
          .filter(storedRule => storedRule.id !== state.deleteRuleRequest.id)
      }
    },
    DELETE_RULE_ERROR_RESPONSE (state, payload) {
      state.deleteRuleRequest.status = LoadState.Error
      state.deleteRuleRequest.response = payload
    },
    DELETE_MAINTENANCE_ITEM_REQUEST (state) {
      state.deleteMaintenanceItemRequest.status = LoadState.Loading
    },
    DELETE_MAINTENANCE_ITEM_RESPONSE (state, payload) {
      state.deleteMaintenanceItemRequest.status = LoadState.Success
      state.deleteMaintenanceItemRequest.response = payload.response

      if (state.getMaintenanceItemsRequest.status === LoadState.Success) {
        state.getMaintenanceItemsRequest.response = state.getMaintenanceItemsRequest.response
          .filter(item => item.id !== payload.id)
      }
    },
    DELETE_MAINTENANCE_ITEM_ERROR_RESPONSE (state, payload) {
      state.deleteMaintenanceItemRequest.status = LoadState.Error
      state.deleteMaintenanceItemRequest.response = payload
    },
    TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_REQUEST (state) {
      state.triggerGisFavoriteSynchronizationRequest.status = LoadState.Loading
    },
    TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_RESPONSE (state, payload) {
      state.triggerGisFavoriteSynchronizationRequest.status = LoadState.Success
      state.triggerGisFavoriteSynchronizationRequest.response = payload
    },
    TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_ERROR_RESPONSE (state, payload) {
      state.triggerGisFavoriteSynchronizationRequest.status = LoadState.Error
      state.triggerGisFavoriteSynchronizationRequest.response = payload
    },
  },

  actions: {
    setStage ({ commit }, { value }) {
      commit('SET_STAGE', value)
    },
    fetchPilots ({ commit, getters }) {
      if (getters.getPilotsStatus === LoadState.Success) {
        return Promise.resolve(getters.getPilots)
      }

      commit('GET_PILOTS_REQUEST')
      return pilotApiClient.getPilots()
        .then(({ data }) => {
          commit('GET_PILOTS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_PILOTS_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchPilotSuggestions ({ commit, getters }) {
      if (getters.getPilotSuggestionsStatus === LoadState.Success) {
        return Promise.resolve(getters.getPilotSuggestions)
      }

      commit('GET_PILOT_SUGGESTIONS_REQUEST')
      return pilotApiClient.getPilotSuggestions()
        .then(({ data }) => {
          commit('GET_PILOT_SUGGESTIONS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_PILOT_SUGGESTIONS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    fetchTags ({ commit, getters }) {
      if (getters.getTagsStatus === LoadState.Success) {
        return Promise.resolve(getters.getTags)
      }

      commit('GET_TAGS_REQUEST')
      return tagApiClient.getTags()
        .then(({ data }) => {
          commit('GET_TAGS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_TAGS_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchQuickActionTags ({ commit, getters }) {
      if (getters.getQuickActionTags === LoadState.Success) {
        return Promise.resolve(getters.getQuickActionTags)
      }

      commit('GET_QUICK_ACTION_TAGS_REQUEST')
      return quickActionApiClient.getQuickActionTags()
        .then(({ data }) => {
          commit('GET_QUICK_ACTION_TAGS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_QUICK_ACTION_TAGS_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchZones ({ commit, getters }) {
      if (getters.getZonesStatus === LoadState.Success) {
        return Promise.resolve(getters.getZones)
      }

      commit('GET_ZONES_REQUEST')
      return zoneApiClient.getZones()
        .then(({ data }) => {
          commit('GET_ZONES_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_ZONES_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchRules ({ commit, getters }) {
      if (getters.getRulesStatus === LoadState.Success) {
        return Promise.resolve(getters.getRules)
      }

      commit('GET_RULES_REQUEST')
      return ruleApiClient.getRules()
        .then(({ data }) => {
          commit('GET_RULES_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_RULES_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchRulesV2 ({ commit, getters }) {
      if (getters.getRulesV2Status === LoadState.Success) {
        return Promise.resolve(getters.getRulesV2)
      }

      commit('GET_RULES_V2_REQUEST')
      return ruleV2ApiClient.getRulesV2()
        .then(({ data }) => {
          commit('GET_RULES_V2_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_RULES_V2_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchMaintenanceItems ({ commit, getters }) {
      commit('GET_MAINTENANCE_ITEMS_REQUEST')
      return maintenanceItemsApiClient.getMaintenanceItems()
        .then(({ data }) => {
          commit('GET_MAINTENANCE_ITEMS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_MAINTENANCE_ITEMS_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    refreshRules ({ commit }) { // refetches rules without triggering loading status
      return ruleApiClient.getRules()
        .then(({ data }) => {
          commit('GET_RULES_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_RULES_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    refreshRulesV2 ({ commit }) { // refetches rules v2 without triggering loading status
      return ruleV2ApiClient.getRulesV2()
        .then(({ data }) => {
          commit('GET_RULES_V2_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_RULES_V2_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    fetchZoneSuggestions ({ commit, getters }) {
      if (getters.getZoneSuggestionsStatus === LoadState.Success) {
        return Promise.resolve(getters.getZoneSuggestions)
      }

      commit('GET_ZONE_SUGGESTIONS_REQUEST')
      return zoneApiClient.getZonesSuggestions()
        .then(({ data }) => {
          commit('GET_ZONE_SUGGESTIONS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_ZONE_SUGGESTIONS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    fetchNotifications ({ commit, getters }, { vehicleId }) {
      if (getters.getNotificationsStatus === LoadState.Success && getters.getNotificationsVehicle === vehicleId) {
        return Promise.resolve(getters.getNotifications)
      }

      commit('GET_NOTIFICATIONS_REQUEST', vehicleId)
      return notificationsApiClient.getVehicleNotifications(vehicleId)
        .then(({ data }) => {
          commit('GET_NOTIFICATIONS_RESPONSE', data.data)
          return data
        })
        .catch((error) => {
          commit('GET_NOTIFICATIONS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    fetchAvailableNotificationChannels ({ commit, getters }) {
      if (getters.getAvailableNotificationChannelStatus === LoadState.Success) {
        return Promise.resolve(getters.getAvailableNotificationChannels)
      }

      commit('GET_AVAILABLE_NOTIFICATION_CHANNELS_REQUEST')
      return notificationsApiClient.getAvailableNotificationChannels()
        .then(({ data }) => {
          commit('GET_AVAILABLE_NOTIFICATION_CHANNELS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_AVAILABLE_NOTIFICATION_CHANNELS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    createPilot ({ commit, dispatch }, { pilot }) {
      commit('CREATE_PILOT_REQUEST')
      return pilotApiClient.createPilot(pilot)
        .then(({ data }) => {
          commit('CREATE_PILOT_RESPONSE', data)
          dispatch('refreshPilotSuggestions')
          return data
        })
        .catch((error) => {
          commit('CREATE_PILOT_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    refreshPilotSuggestions ({ commit }) { // refetches suggestion without triggering load state
      return pilotApiClient.getPilotSuggestions()
        .then(({ data }) => {
          commit('GET_PILOT_SUGGESTIONS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_PILOT_SUGGESTIONS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    refreshZoneSuggestions ({ commit }) { // refetches suggestion without triggering load state
      return zoneApiClient.getZonesSuggestions()
        .then(({ data }) => {
          commit('GET_ZONE_SUGGESTIONS_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('GET_ZONE_SUGGESTIONS_ERROR_RESPONSE', error.response)
          return error
        })
    },
    createTag ({ commit }, { tag }) {
      commit('CREATE_TAG_REQUEST')
      return tagApiClient.createTag(tag)
        .then(({ data }) => {
          commit('CREATE_TAG_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('CREATE_TAG_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    createZone ({ commit, dispatch, getters }, { zone }) {
      commit('CREATE_ZONE_REQUEST')
      return zoneApiClient.createZone(zone)
        .then(({ data }) => {
          commit('CREATE_ZONE_RESPONSE', data)
          dispatch('Triplog/zoneCreated', { zones: getters.getZones }, { root: true })
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('CREATE_ZONE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    createRule ({ commit }, { rule }) {
      commit('CREATE_RULE_REQUEST')
      return ruleApiClient.createRule(rule)
        .then(({ data }) => {
          commit('CREATE_RULE_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('CREATE_RULE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    createRuleV2 ({ commit }, { rule }) {
      commit('CREATE_RULE_V2_REQUEST')
      return ruleV2ApiClient.createRuleV2(rule)
        .then(({ data }) => {
          commit('CREATE_RULE_V2_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('CREATE_RULE_V2_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    createMaintenanceItem ({ commit, dispatch }, { vehicleId, maintenanceItem }) {
      commit('CREATE_MAINTENANCE_ITEM_REQUEST')
      return maintenanceItemsApiClient.createMaintenanceItems(vehicleId, maintenanceItem)
        .then(({ data }) => {
          commit('CREATE_MAINTENANCE_ITEM_RESPONSE', data)
          dispatch('fetchMaintenanceItems')
          dispatchResetCarHealth(dispatch)
          return data
        })
        .catch((error) => {
          commit('CREATE_MAINTENANCE_ITEM_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updatePilot ({ commit, dispatch }, { id, pilot }) {
      commit('UPDATE_PILOT_REQUEST', id)
      return pilotApiClient.updatePilot(id, pilot)
        .then(({ data }) => {
          commit('UPDATE_PILOT_RESPONSE', data)
          dispatch('Triplog/pilotUpdated', { pilot: data }, { root: true })
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('UPDATE_PILOT_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateTag ({ commit, dispatch }, { id, tag }) {
      commit('UPDATE_TAG_REQUEST', id)
      return tagApiClient.updateTag(id, tag)
        .then(({ data }) => {
          commit('UPDATE_TAG_RESPONSE', data)
          dispatch('Triplog/tagUpdated', { tag: data }, { root: true })
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('UPDATE_TAG_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateZone ({ commit, dispatch, getters }, { id, zone }) {
      commit('UPDATE_ZONE_REQUEST', id)
      return zoneApiClient.updateZone(id, zone)
        .then(({ data }) => {
          commit('UPDATE_ZONE_RESPONSE', data)
          dispatch('Triplog/zoneUpdated', { zones: getters.getZones }, { root: true })
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('UPDATE_ZONE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateRule ({ commit }, { id, rule }) {
      commit('UPDATE_RULE_REQUEST', id)
      return ruleApiClient.updateRule(id, rule)
        .then(({ data }) => {
          commit('UPDATE_RULE_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('UPDATE_RULE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateRuleV2 ({ commit }, { id, rule }) {
      commit('UPDATE_RULE_V2_REQUEST', id)
      return ruleV2ApiClient.updateRuleV2(id, rule)
        .then(({ data }) => {
          commit('UPDATE_RULE_V2_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('UPDATE_RULE_V2_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateRuleActive ({ commit }, { id, ruleActive }) {
      commit('UPDATE_RULE_ACTIVE_REQUEST', {id, active: ruleActive.active})
      return ruleApiClient.updateRuleActive(id, ruleActive)
        .then(({ data }) => {
          commit('UPDATE_RULE_ACTIVE_RESPONSE', ruleActive.active)
          return data
        })
        .catch((error) => {
          commit('UPDATE_RULE_ACTIVE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateMaintenanceItem ({ commit, dispatch }, { vehicleId, id, maintenanceItem }) {
      commit('UPDATE_MAINTENANCE_ITEM_REQUEST')
      return maintenanceItemsApiClient.updateMaintenanceItems(vehicleId, id, maintenanceItem)
        .then(({ data }) => {
          commit('UPDATE_MAINTENANCE_ITEM_RESPONSE', data)
          dispatch('fetchMaintenanceItems')
          dispatchResetCarHealth(dispatch)
          return data
        })
        .catch((error) => {
          commit('UPDATE_MAINTENANCE_ITEM_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    updateMaintenanceItemActive ({ commit, dispatch }, { vehicleId, id, active }) {
      commit('UPDATE_MAINTENANCE_ITEM_ACTIVE_REQUEST', { id, active })
      return maintenanceItemsApiClient.updateMaintenanceItemActive(vehicleId, id, { active })
        .then(({ data }) => {
          commit('UPDATE_MAINTENANCE_ITEM_ACTIVE_RESPONSE', { active: active, id })
          dispatchResetCarHealth(dispatch)
          return data
        })
        .catch((error) => {
          commit('UPDATE_MAINTENANCE_ITEM_ACTIVE_ERROR_RESPONSE', { response: error.response, id })
          throw error
        })
    },
    updateNotification ({ commit, dispatch }, { vehicleId, notification, updateFromOverview = false }) {
      commit('UPDATE_NOTIFICATION_REQUEST', { notification, updateFromOverview })
      return notificationsApiClient.changeVehicleNotifications(vehicleId, { data: notification })
        .then(({ data }) => {
          commit('UPDATE_NOTIFICATION_RESPONSE', notification)
          return data
        })
        .catch((error) => {
          commit('UPDATE_NOTIFICATION_ERROR_RESPONSE', error.response)
          if (updateFromOverview) {
            dispatch('fetchNotifications', vehicleId)
          }
          throw error
        })
    },
    updateNotificationActive ({ commit }, { vehicleId, active }) {
      commit('UPDATE_NOTIFICATION_ACTIVE_REQUEST', active)
      return notificationsApiClient.changeVehicleNotificationActive(vehicleId, { data: active })
        .then(({ data }) => {
          commit('UPDATE_NOTIFICATION_ACTIVE_RESPONSE')
          return data
        })
        .catch((error) => {
          commit('UPDATE_NOTIFICATION_ACTIVE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    deletePilot ({ commit, dispatch }, { id }) {
      commit('DELETE_PILOT_REQUEST', id)
      return pilotApiClient.deletePilot(id)
        .then(({ data }) => {
          commit('DELETE_PILOT_RESPONSE', data)
          dispatch('Triplog/pilotDeleted', { id }, { root: true })
          dispatch('refreshPilotSuggestions')
          dispatchRefreshRules(dispatch)
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('DELETE_PILOT_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    deleteTag ({ commit, dispatch }, { id }) {
      commit('DELETE_TAG_REQUEST', id)
      return tagApiClient.deleteTag(id)
        .then(({ data }) => {
          commit('DELETE_TAG_RESPONSE', data)
          dispatch('Triplog/tagDeleted', { id }, { root: true })
          dispatchRefreshRules(dispatch)
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('DELETE_TAG_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    deleteZone ({ commit, dispatch, getters }, { id }) {
      commit('DELETE_ZONE_REQUEST', id)
      return zoneApiClient.deleteZone(id)
        .then(({ data }) => {
          commit('DELETE_ZONE_RESPONSE', data)
          dispatch('Triplog/zoneDeleted', { zones: getters.getZones }, { root: true })
          dispatchRefreshRules(dispatch)
          dispatchResetStatistics(dispatch)
          return data
        })
        .catch((error) => {
          commit('DELETE_ZONE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    deleteRule ({ commit, dispatch }, { id }) {
      commit('DELETE_RULE_REQUEST', id)
      return ruleApiClient.deleteRule(id)
        .then(({ data }) => {
          commit('DELETE_RULE_RESPONSE', data)
          dispatchRefreshRules(dispatch)
          return data
        })
        .catch((error) => {
          commit('DELETE_RULE_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    deleteMaintenanceItem ({ commit, dispatch }, { vehicleId, id }) {
      commit('DELETE_MAINTENANCE_ITEM_REQUEST', id)
      return maintenanceItemsApiClient.deleteMaintenanceItem(vehicleId, id)
        .then(({ data }) => {
          commit('DELETE_MAINTENANCE_ITEM_RESPONSE', { response: data, id, vehicleId })
          dispatchResetCarHealth(dispatch)
          return data
        })
        .catch((error) => {
          commit('DELETE_MAINTENANCE_ITEM_ERROR_RESPONSE', error.response)
          throw error
        })
    },
    triggerGisFavoriteSynchronization ({ commit, getters }) {
      if (getters.triggerGisFavoriteSynchronizationStatus === LoadState.Success) {
        return Promise.resolve(getters.getGisFavoriteSynchronizationResult)
      }

      commit('TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_REQUEST')
      return zoneApiClient.triggerGisFavoriteSynchronization()
        .then(({ data }) => {
          commit('TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_RESPONSE', data)
          return data
        })
        .catch((error) => {
          commit('TRIGGER_GIS_FAVORITE_SYNCHRONIZATION_ERROR_RESPONSE', error.response)
          throw error
        })
    },
  },

  getters: {
    getStage: state => state.stage,
    getPilotsStatus: state => state.getPilotsRequest.status,
    getPilots: (state, getters) => {
      if (getters.getPilotsStatus !== LoadState.Success) {
        return state.getPilotsRequest.response
      }

      if (getters.getRulesV2Status !== LoadState.Success) {
        return state.getPilotsRequest.response.map(p => ({ ...p, associatedRules: [] }))
      }

      return state.getPilotsRequest.response.map(p => {
        const associatedRules = getters.getRulesV2.filter(r => parseInt(r.pilotId) === p.id)
        return { ...p, associatedRules }
      })
    },
    getFilterPilots: (state, getters) => [{ id: -1, name: 'Kein Fahrer' }, ...getters.getPilots.map(p => ({ id: p.id, name: `${p.firstname} ${p.lastname}` }))],
    getPilotSuggestionsStatus: state => state.getPilotSuggestionsRequest.status,
    getPilotSuggestions: state => state.getPilotSuggestionsRequest.response,
    getZoneSuggestionsStatus: state => state.getZoneSuggestionsRequest.status,
    getZoneSuggestions: state => state.getZoneSuggestionsRequest.response,
    getTagsStatus: state => state.getTagsRequest.status,
    getTags: (state, getters) => {
      if (getters.getTagsStatus !== LoadState.Success) {
        return state.getTagsRequest.response
      }

      if (getters.getRulesV2Status !== LoadState.Success) {
        return state.getTagsRequest.response.map(t => ({ ...t, associatedRules: [] }))
      }

      return state.getTagsRequest.response.map(t => {
        const associatedRules = getters.getRulesV2.filter(r => parseInt(r.tagId) === t.id)
        return { ...t, associatedRules }
      })
    },
    getQuickActionTagsStatus: state => state.getQuickActionTagsRequest.status,
    getQuickActionTags: (state, getters) => {
      return state.getQuickActionTagsRequest.response
    },
    getFilterTags: (state, getters) => [{ id: -1, name: 'Keine Kategorie' }, ...getters.getTags],
    getZonesStatus: state => state.getZonesRequest.status,
    getZones: (state, getters) => {
      if (getters.getZonesStatus !== LoadState.Success) {
        return state.getZonesRequest.response
      }

      if (getters.getRulesV2Status !== LoadState.Success) {
        return state.getZonesRequest.response.map(z => ({ ...z, associatedRules: [] }))
      }

      return state.getZonesRequest.response.map(z => {
        const associatedRules = getters.getRulesV2.filter(r => r.zoneIds.includes(z.id))
        return { ...z, associatedRules }
      })
    },
    getFilterZones: (state, getters) => [{ id: -1, name: 'Keine Zone' }, ...getters.getZones],
    getRulesStatus: state => state.getRulesRequest.status,
    getRules: (state, getters) => {
      if (getters.getRulesStatus !== LoadState.Success) {
        return state.getRulesRequest.response
      }

      return state.getRulesRequest.response.map(r => {
        if (getters.getPilotsStatus === LoadState.Success) {
          r.pilot = state.getPilotsRequest.response.find(p => p.id === parseInt(r.pilotId))
        }

        if (getters.getTagsStatus === LoadState.Success) {
          r.tag = state.getTagsRequest.response.find(t => t.id === parseInt(r.tagId))
        }

        if (getters.getZonesStatus === LoadState.Success) {
          r.zone = state.getZonesRequest.response.find(z => z.id === parseInt(r.personalZoneId))
        }

        return r
      })
    },
    getRulesV2Status: state => state.getRulesV2Request.status,
    getRulesV2: (state, getters) => {
      if (getters.getRulesV2Status !== LoadState.Success) {
        return state.getRulesV2Request.response
      }

      return state.getRulesV2Request.response.map(r => {
        if (getters.getPilotsStatus === LoadState.Success) {
          r.pilot = state.getPilotsRequest.response.find(p => p.id === parseInt(r.pilotId))
        }

        if (getters.getTagsStatus === LoadState.Success) {
          r.tag = state.getTagsRequest.response.find(t => t.id === parseInt(r.tagId))
        }

        if (getters.getZonesStatus === LoadState.Success) {
          r.zone = state.getZonesRequest.response.find(z => z.id === parseInt(r.personalZoneId))
        }

        return r
      })
    },
    getNotifications: state => state.getNotificationsRequest.response,
    getNotificationsStatus: state => state.getNotificationsRequest.status,
    getNotificationsVehicle: state => state.getNotificationsRequest.vehicleId,
    getNotificationUpdateStatus: state => state.updateNotificationRequest.status,
    getNotificationActiveUpdateStatus: state => state.updateNotificationActiveRequest.status,
    getAvailableNotificationChannelStatus: state => state.getAvailableNotificationChannelsRequest.status,
    getAvailableNotificationChannels: state => state.getAvailableNotificationChannelsRequest.response,
    getMaintenanceItemsStatus: state => state.getMaintenanceItemsRequest.status,
    getMaintenanceItems: state => state.getMaintenanceItemsRequest.response,
    triggerGisFavoriteSynchronizationStatus: state => state.triggerGisFavoriteSynchronizationRequest.status,
    getGisFavoriteSynchronizationResult: state => state.triggerGisFavoriteSynchronizationRequest.response,
  }
}
